import { ScalingPolicyWithWorkloads } from '../../../../_types';

export const getPreselectedPolicyId = (
  workloadIds: string[],
  policies: ScalingPolicyWithWorkloads[]
): string | undefined => {
  const workloadIdsByPolicy: Record<string, string[]> = {};
  for (const workloadId of workloadIds) {
    for (const { id: policyId, workloads } of policies) {
      if (workloads.some(({ id }) => id === workloadId)) {
        const policyWorkloads = workloadIdsByPolicy[policyId] || [];
        policyWorkloads.push(workloadId);
        workloadIdsByPolicy[policyId] = policyWorkloads;
      }
      if (Object.keys(workloadIdsByPolicy).length > 1) {
        return undefined;
      }
    }
  }
  const [key, ids] = Object.entries(workloadIdsByPolicy)[0] || [];

  if (!ids?.length) {
    return undefined;
  }
  const allWorkloadsAssignedToTheSamePolicy = workloadIds.every((id) =>
    ids.includes(id)
  );
  if (allWorkloadsAssignedToTheSamePolicy) {
    return key;
  }
  return undefined;
};
